import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import DashboardLayout from "@/components/DashboardLayout";
import PracticeForm from "@/components/PracticeForm";
import { ChevronLeft } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";

export default function ConsultantNewPractice() {
  const navigate = useNavigate();
  const [allowed, setAllowed] = useState(["photo"]);

  useEffect(() => {
    api.get("/consultant/me")
      .then(({ data }) => setAllowed(data.allowed_media_types || ["photo"]))
      .catch(() => {});
  }, []);

  return (
    <DashboardLayout role="consultant">
      <div className="p-4 sm:p-8 max-w-3xl">
        <button onClick={() => navigate("/dashboard")} data-testid="new-back-button"
          className="inline-flex items-center gap-1 text-sm text-slate-500 hover:text-[#2456C6] mb-4">
          <ChevronLeft className="w-4 h-4" /> Torna all&apos;elenco
        </button>

        <h1 className="text-2xl sm:text-3xl font-black text-[#1E293B] mb-1">Nuova pratica</h1>
        <p className="text-sm text-slate-500 mb-6">
          Apri una pratica per conto del cliente (es. cliente al telefono, cliente sul posto, raccolta dati on-site).
          Puoi richiedere la firma OTP via email subito o farlo più tardi.
        </p>

        <PracticeForm
          mode="consultant"
          showClientFields={true}
          requestSignature={false}
          allowedMediaTypes={allowed}
          onSubmitted={(data) => {
            toast.success(`Pratica ${data.code} creata`);
            navigate(`/dashboard/practice/${data.id}`);
          }}
        />
      </div>
    </DashboardLayout>
  );
}
